import { IStore } from '../../index'

const getSliderTab = (state: IStore) => state.userAccount.sliderTab

export default getSliderTab
